import { render, staticRenderFns } from "./ChatbotEmbed.vue?vue&type=template&id=567a62a0&scoped=true&"
import script from "./ChatbotEmbed.vue?vue&type=script&lang=js&"
export * from "./ChatbotEmbed.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotEmbed.vue?vue&type=style&index=0&id=567a62a0&scoped=true&lang=less&"
import style1 from "./ChatbotEmbed.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a62a0",
  null
  
)

export default component.exports